// extracted by mini-css-extract-plugin
export var center = "_4k-2";
export var clickableRow = "_4k-5";
export var expandedRow = "_4k-7";
export var hoverable = "_4k-4";
export var left = "_4k-1";
export var right = "_4k-3";
export var row = "_4k-0";
export var selectedRow = "_4k-6";
export var summaryRow = "_4k-8";